<script>
  export let info;
</script>

<style>
</style>

<div>
  {@html info}
</div>
